module.exports = __webpack_public_path__ + "static/media/A1-F1-Zyberion Nexus-codF3.98fa60d8.png";